
import React, { useEffect, useState, useRef,useContext } from 'react';
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { ContenedorTabla } from '../../components/utils/ContenedorTabla';
import { Modal } from '../../components/modal/Modal';
import { SearchTable } from '../../components/utils/SearchTable';
import { useSugerencias } from '../../../hooks/useSugerencias';
import { Tooltip } from '../../components/utils/Tooltip';
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { DatePickerDoble } from '../../components/pickers/DatePickerDoble';
export const SugerenciasAC = () => {
    const idTablaSugerencia = 'idTablaSugerencia';
    const [ codigoSugerencia, setCodigoSugerencia ] = useState(0);
    const [ startDate, setStartDate ] = useState(new Date())
    const [ endDate, setEndDate ] = useState(new Date())
    const [ identificador, setIdentificador ] = useState(1)
    const {
        sugerenciasAC ,
        listarSugerenciaPorAplicativo,
        sugerenciaAC,
        obtenerDetalleSugerencia,
        isOpenModalDetalle,
        openModalDetalle,
        closeModalDetalle,
        eliminarComentarioSugerencia,
        editarValorSugerencia,
        comentarioSugerencia,
        isOpenModalEliminar,
        openModalEliminar,
        closeModalEliminar,


    } = useSugerencias();

    useEffect(() => {
        listarSugerenciaPorAplicativo(startDate, endDate)
    },[startDate,endDate])

    const guardaEliminarSugerencia = async (identificador) => {
        const isValid = await eliminarComentarioSugerencia(identificador);
        if(isValid){
            closeModalEliminar()
            editarValorSugerencia('motivo','')
            identificador === 1 ? listarSugerenciaPorAplicativo(startDate, endDate) : obtenerDetalleSugerencia(codigoSugerencia)
        }
    } 

    return(
        <>
            <ContenedorParametros titulo='Sugerencias'>
                <DatePickerDoble
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
                <BotonProcesar onClick={() =>listarSugerenciaPorAplicativo(startDate,endDate)}></BotonProcesar>

                <SearchTable tablaId={idTablaSugerencia}></SearchTable>
            </ContenedorParametros>
            <ContenedorTabla>
                <table className='table' id={idTablaSugerencia}>
                    <thead>
                        <tr key={idTablaSugerencia + 1}>
                            <th className='text-left'>N</th>
                            <th className='text-left'>{'Código'.toUpperCase()}</th>
                            <th className='text-left'>{'Sugerencia'.toUpperCase()}</th>
                            <th className='text-left'>{'Usuario'.toUpperCase()}</th>
                            <th className='text-left'>{'F. registro'.toUpperCase()}</th>
                            <th className='text-left' data-tip={'like'} data-for={'like'}>
                                <i className="fa fa-thumbs-up"></i>
                                <Tooltip id={'like'}>Cantidad de "Me gusta"</Tooltip>
                            </th>
                            <th className='text-left' data-tip={'dislike'} data-for={'dislike'}>
                                <i className="fa fa-thumbs-down"></i>
                                <Tooltip id={'dislike'}>Cantidad de "No me gusta"</Tooltip>
                            </th>
                            <th className='text-left'></th>
                            <th className='text-left'></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            sugerenciasAC.length > 0 ?
                            sugerenciasAC.map((s,i) =>(
                                    <tr key={i+1}>
                                        <td>{i + 1}</td>
                                        <td>
                                            <label
                                            className='flex w-[50px] rounded justify-center bg-blue-600 font-semibold'
                                            >{s.codUsuarioSugerencia}</label>

                                        </td>
                                        <td>{s.comentario}</td>
                                        <td>{s.uidCreacion}</td>
                                        <td>{s.fechaHoraCreacion}</td>
                                        {/* <td>{s.CantidadRespuestas}</td> */}
                                        <td>{s.numReaccionLike}</td>
                                        <td>{s.numReaccionDislike}</td>
                                        <td className='w-[40px]'>
                                            <button
                                                className='bg-blue-600 px-2 rounded'
                                                data-tip={'detalleSugerencia'}
                                                data-for={'detalleSugerencia'}
                                                onClick={async ()=> {
                                                    await obtenerDetalleSugerencia(s.codUsuarioSugerencia);
                                                    setCodigoSugerencia(s.codUsuarioSugerencia)
                                                    openModalDetalle();
                                                }}
                                            >
                                                <i className='fa fa-bars'></i>
                                            </button>
                                            <Tooltip id={'detalleSugerencia'}>Detalle de sugerencia</Tooltip>
                                        </td>
                                        <td className='w-[40px]'>
                                            <button
                                                className='bg-red-600 px-2 rounded'
                                                data-tip={'eliminarSugerencia'}  
                                                data-for={'eliminarSugerencia'}
                                                onClick={() => {
                                                    editarValorSugerencia('codUsuarioSugerencia',s.codUsuarioSugerencia)
                                                    setIdentificador(1)
                                                    openModalEliminar()
                                                }} 
                                            >
                                                <i className='fa fa-light fa-trash'></i>
                                            </button>
                                            <Tooltip id={'eliminarSugerencia'}>Eliminar sugerencia</Tooltip>
                                        </td>
                                    </tr>
                                ))
                            :
                            <tr>
                                <td colSpan={9} className='text-center'>No hay información para mostrar...</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </ContenedorTabla>
            {/** Modal para ver detalle */}
            <Modal
                isOpen={isOpenModalDetalle}
                closeModal={closeModalDetalle}
                title={`Respuestas de sugerencia [ Código: ${codigoSugerencia} ]`}
                validButton={{confirm: false,denied: true}}
            >
                {
                    isOpenModalDetalle &&
                    <div className='w-full text-xl]'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th className='text-left'>N</th>
                                    <th className='text-left'>Comentario</th>
                                    <th className='text-left'>Usuario</th>
                                    <th className='text-left w-[150px]'>Fecha</th>
                                    <th className='text-left'>
                                        <i
                                            className="fa fa-thumbs-o-up"
                                            data-tip={'cantLike'}
                                            data-for={'cantLike'}
                                        ></i>
                                        <Tooltip id={'cantLike'}>Cantidad de "Me gusta"</Tooltip>
                                    </th>
                                    <th className='text-left'>
                                        <i
                                            className="fa fa-thumbs-o-down"
                                            data-tip={'cantDislike'}
                                            data-for={'cantDislike'}
                                        ></i>
                                        <Tooltip id={'cantDislike'}>Cantidad de "No me gusta"</Tooltip>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    sugerenciaAC.length > 0 ?
                                        sugerenciaAC.map((s,i) => (
                                            <tr>
                                                <td>{i + 1}</td>
                                                <td className='w-[330px]'>
                                                    <div
                                                        className='w-[328px] text-ellipsis whitespace-nowrap overflow-hidden'
                                                    >{s.comentario}</div>
                                                </td>
                                                <td>{s.uidCreacion}</td>
                                                <td className='whitespace-nowrap'>{s.fechaHoraCreacion}</td>
                                                <td>{s.numReaccionLike}</td>
                                                <td>{s.numReaccionDislike}</td>
                                                <td>
                                                    <button
                                                        className='bg-red-600 px-2 rounded'
                                                        data-tip={'eliminarComentario'}  
                                                        data-for={'eliminarComentario'}
                                                        onClick={() =>{
                                                            editarValorSugerencia('codUsuarioSugerencia',s.codUsuarioSugerenciaComentario)
                                                            setIdentificador(2)
                                                            openModalEliminar()
                                                        }}
                                                    >
                                                        <i className='fa fa-trash-o'></i>
                                                    </button>
                                                    <Tooltip id={'eliminarComentario'}>Eliminar comentario</Tooltip>
                                                </td>
                                            </tr>
                                        ))
                                    :
                                    <tr>
                                        <td className='text-center' colSpan={7}>No hay información para mostrar...</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                        {}
                    </div>

                }
            </Modal>
            {/* Modal para eliminar sugerencia */}
            <Modal
                isOpen={isOpenModalEliminar}
                closeModal={closeModalEliminar}
                title={`${identificador === 1 ? `Eliminar sugerencia [ Código: ${codigoSugerencia} ]` : `Eliminar comentario`}`}
                action={() => guardaEliminarSugerencia(identificador)}
                validButton={{
                    confirm: true,
                    denied: true
                }}
                textButtons={{
                    confirm: 'Si',
                    denied: 'No'
                }}
            >
                {
                    isOpenModalEliminar &&
                    <div className='w-[350px]'>
                        <div className='flex flex-col items-center gap-2'>
                            <img
                                src='https://upload.wikimedia.org/wikipedia/commons/1/11/Blue_question_mark_icon.svg'
                                className='w-[40px] h-[40px]'
                                alt=''
                            />
                            <span>¿Esta seguro de realizar la operación?</span>
                        </div>
                        <div class="w-full flex flex-col py-1">
                            <span className=" text-left">Motivo:</span>
                            <textarea
                                className="lg:w-full w-full p-2 caret-white containerScroll 
                                text-white h-[70px] rounded  bg-zinc-800 text-l
                                focus:outline-none focus:ring-1 focus:ring-blue-500"
                                value={comentarioSugerencia.motivo}
                                onChange={(e) => {
                                    editarValorSugerencia('motivo',e.target.value)
                                }}
                            ></textarea>
                        </div>
                    </div>
                }

            </Modal>
        </>
    )
}